import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";
function Resetpassword() {
  const [product, setProduct] = useState([]);
  const [search, setSearch] = useState([""]);
  const [show, setShow] = useState(false);
  const [pass, setPass] = useState({});
  const [dmr_idState, setdmr_id] = useState();
  const [email, setEmail] = useState("");
  const getProductData = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/marketer/get-all-marketer`
      );

      console.log(data.data);
      setProduct(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);

  const HandleFormData = (event) => {
    setPass({ ...pass, [event.target.name]: event.target.value });
  };
  const sendConfirm = () => {
    console.log(pass, "passsss")
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/admin/marketer/change-password/` +
          dmr_idState, 
        {
          email: email,
          password: pass.password,
          confirm_password: pass.confirm_password,
        }
      )
      .then(function (response) {
        if (response.status === 200){
          alert("password changed");
        }
       
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <>
      <h2>Marketer Reset Password</h2>
      <div className="text-end">
        <input
          name="search"
          type="text"
          placeholder="search here"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <div className="overflow-y-scroll px-5 py-3">
        <table className="table table-bordered border-primary table-hover ">
          <thead className="table-dark ">
            <tr>
              <th scope="col">S.NO</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Company</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {console.log(product, "product")}
            {product.data !== undefined
              ? product.data
                  .filter((item) => {
                    if (search === "") {
                      return item;
                    } else if (item.email.includes(search)) {
                      return item;
                    }
                  })
                  .map((item, index) => {
                    return (
                      <tr>
                        <th scope="row">{index}</th>
                        <td>{item.firstname + item.lastname}</td>
                        <td>{item.email}</td>
                        <td>{item.mobile}</td>
                        <td>{item.company}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              setShow(true);
                              setdmr_id(item.dmr_id);
                              setEmail(item.email);
                            }}
                          >
                            Change Password
                          </button>
                        </td>
                      </tr>
                    );
                  })
              : null}
          </tbody>
        </table>
        <Modal show={show} centered size="lg">
          <Modal.Title>Reset Password</Modal.Title>
          <ModalBody>
            <label className="form-label float-start mt-3">New Password:</label>
            <input
              className="form-control"
              type="password"
              name="password"
              id="pwd"
              onChange={(event) => HandleFormData(event)}
            ></input>
            <label className="form-label float-start mt-3">
              Confirm Password:
            </label>
            <input
              className="form-control"
              type="password"
              name="confirm_password"
              id="password"
              onChange={(event) => HandleFormData(event)}
            ></input>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              onClick={() => {
                sendConfirm();
              }}
            >
              Send
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setShow(false);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}
export default Resetpassword;
